import React from 'react';

const DaysOfWeekInput = (props) => {
    const getClassnames = (day) => {
        if (props.value && props.value.includes(day)) {
            return `button primary`;
        } else {
            return `button secondary`;
        }
    }

    const setDay = (event, day) => {
        event.preventDefault();

        let newValue = props.value ?? [];

        if (newValue.includes(day)) {
            newValue = removeFromArray(newValue, day);
        } else {
            newValue.push(day)
        }

        newValue.sort()

        props.onChange(newValue);
    }

    const removeFromArray = (array, value) => {
        for (var i = array.length - 1; i >= 0; i--) {
            if (array[i] === value) {
                array.splice(i, 1);
            }
        }
        return array;
    }
    return (
        <div className="button-group days-of-week-input">
            <button
                className={getClassnames(1)}
                onClick={(e) => setDay(e, 1)}
            >M</button>
            <button
                className={getClassnames(2)}
                onClick={(e) => setDay(e, 2)}
            >T</button>
            <button
                className={getClassnames(3)}
                onClick={(e) => setDay(e, 3)}
            >W</button>
            <button
                className={getClassnames(4)}
                onClick={(e) => setDay(e, 4)}
            >T</button>
            <button
                className={getClassnames(5)}
                onClick={(e) => setDay(e, 5)}
            >F</button>
            <button
                className={getClassnames(6)}
                onClick={(e) => setDay(e, 6)}
            >S</button>
            <button
                className={getClassnames(0)}
                onClick={(e) => setDay(e, 0)}
            >S</button>
        </div>
    );
}

export default DaysOfWeekInput;
